import { offerApi } from "../features/offer/api/offerApi.js";
import { setError } from "../features/offer/slices/offerSlice.js";
import { getErrorMessage, getQueryParams } from "../helpers/index.js";

import { AppDispatch } from "./store.js";
let promise = null;
let resolved = false;

export const hydrateStore = async () => {
  if (resolved) return Promise.resolve();
  if (promise) return promise;

  promise = (async () => {
    const { q, co } = getQueryParams();

    try {
      if (co) {
        if (q) {
          await AppDispatch(offerApi.endpoints.getOffer.initiate()).unwrap();
        } else {
          await AppDispatch(offerApi.endpoints.getVRMData.initiate()).unwrap();
        }
      }
    } catch ({ data }) {
      AppDispatch(setError(getErrorMessage(data)));

      throw data;
    } finally {
      promise = null;
    }
  })();

  return promise;
};
